import * as React from "react";
export var BigCharacter = function (_a) {
    var name = _a.name, _b = _a.idStyle, idStyle = _b === void 0 ? "" : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    return React.createElement("div", { className: "big-character-ui " + name + " " + className + " " + idStyle });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/big-character/BigCharacter.tsx
// module id = 156
// module chunks = 3